import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = 'radious:event-campaign-attribution';
const WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
const MAX_RECORDS = 32;

export type EventCampaignAttribution = {
  qr_slug: string;
  attributed_at: string;
};

type StoredAttribution = EventCampaignAttribution & { event_id: string };

export async function rememberEventCampaignAttribution(eventID: string, qrSlug?: string) {
  const slug = qrSlug?.trim();
  if (!eventID || !slug) return;

  const now = Date.now();
  const records = (await readAttributions(now)).filter((record) => record.event_id !== eventID);
  records.push({ event_id: eventID, qr_slug: slug, attributed_at: new Date(now).toISOString() });
  await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(records.slice(-MAX_RECORDS)));
}

export async function getEventCampaignAttribution(
  eventID: string
): Promise<EventCampaignAttribution | undefined> {
  const record = (await readAttributions(Date.now())).find((item) => item.event_id === eventID);
  if (!record) return undefined;
  return { qr_slug: record.qr_slug, attributed_at: record.attributed_at };
}

async function readAttributions(now: number): Promise<StoredAttribution[]> {
  try {
    const parsed = JSON.parse((await AsyncStorage.getItem(STORAGE_KEY)) ?? '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (record): record is StoredAttribution =>
        typeof record?.event_id === 'string' &&
        typeof record?.qr_slug === 'string' &&
        typeof record?.attributed_at === 'string' &&
        now - Date.parse(record.attributed_at) <= WINDOW_MS &&
        Date.parse(record.attributed_at) <= now + 5 * 60 * 1000
    );
  } catch {
    return [];
  }
}
